import { testResultApi } from './index'

export default testResultApi.middleware
